<template>
    <!-- 订单管理/积分订单管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'adminPointOrder')">
            <template slot="header">
                <div class="not-default-form">
                    <a-form :form="fliterForm">
                        <a-row>
                            <a-col :span="8">
                                <a-form-item label="会员手机号" :labelCol="{span:6}" :wrapperCol="{span:16}">
                                    <a-input  style="width:100%;" placeholder="请输入" v-decorator="['phone']" @pressEnter="search(false)"></a-input>
                                </a-form-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-item label="交易订单号" :labelCol="{span:6}" :wrapperCol="{span:16}">
                                    <a-input style="width:100%;" placeholder="请输入" v-decorator="['tradeNo']" @pressEnter="search(false)"></a-input>
                                </a-form-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-item label="交易状态" :labelCol="{span:6}" :wrapperCol="{span:16}">
                                    <a-select :options="$commonOptions.ticketTradeStatusOptions" style="width:100%;" allowClear placeholder="请选择" v-decorator="['tradeState']" @select="search(false)"></a-select>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="8">
                                <a-form-item label="商品类型" :labelCol="{span:6}" :wrapperCol="{span:16}">
                                    <a-select style="width:100%;" allowClear placeholder="请选择" v-decorator="['goodsType']" @select="search(false)">
                                        <a-select-option value="TICKET">票券</a-select-option>
                                        <a-select-option value="COUPON">优惠券</a-select-option>
                                        <a-select-option value="RETAIL">实物</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-item label="下单时间" :labelCol="{span:6}" :wrapperCol="{span:16}">
                                    <a-range-picker
                                        style="width:100%;"
                                        format="YYYY/MM/DD"
                                        v-decorator="['orderTime']"
                                        @cahnge="search(false)"
                                    />
                                </a-form-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-item label="支付时间" :labelCol="{span:6}" :wrapperCol="{span:16}">
                                    <a-range-picker
                                        style="width:100%;"
                                        format="YYYY/MM/DD"
                                        v-decorator="['payTime']"
                                        @change="search(false)"
                                    />
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="8">
                                <a-row>
                                    <a-col :span="6" class="ant-form-item-label">
                                        <label>应收积分</label>
                                    </a-col>
                                    <a-col :span="16">
                                        <a-input-group compact>
                                            <a-form-item style="width: 40%;">
                                                <a-input-number v-decorator="['minOrderPoint']" :min="0" :max="99999999" style="width: 100%; border-radius: 4px 0 0 4px;text-align: center" placeholder="最小积分" />
                                            </a-form-item>
                                            <a-input style="text-align: center;width: 20%;border-left: 0;pointer-events: none;backgroundColor: #fff" placeholder="~" disabled />
                                            <a-form-item style="width: 40%;">
                                                <a-input-number v-decorator="['maxOrderPoint']" :min="0" :max="99999999" style="width: 100%; border-radius: 0 4px 4px 0;text-align: center; border-left: 0" placeholder="最大积分" />
                                            </a-form-item>
                                        </a-input-group>
                                    </a-col>
                                </a-row>
                            </a-col>
                            <a-col :span="8">
                                <a-row>
                                    <a-col :span="6" class="ant-form-item-label">
                                        <label>实收积分</label>
                                    </a-col>
                                    <a-col :span="16">
                                        <a-input-group compact>
                                            <a-form-item style="width: 40%;">
                                                <a-input-number v-decorator="['minPayPoint']" :min="0" :max="99999999" style="width: 100%; border-radius: 4px 0 0 4px;text-align: center" placeholder="最小积分" />
                                            </a-form-item>
                                            <a-input style="text-align: center;width: 20%;border-left: 0;pointer-events: none;backgroundColor: #fff" placeholder="~" disabled />
                                            <a-form-item style="width: 40%;">
                                                <a-input-number v-decorator="['maxPayPoint']" :min="0" :max="99999999" style="width: 100%; border-radius: 0 4px 4px 0;text-align: center; border-left: 0" placeholder="最大积分" />
                                            </a-form-item>
                                        </a-input-group>
                                    </a-col>
                                </a-row>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="23" class="text-right">
                                <a-button @click="search(false)" class="mr8" type="primary" :loading="t_loading">筛选</a-button>
                                <a-button @click="handleReset">重置</a-button>
                            </a-col>
                        </a-row>
                    </a-form>
                </div>
            </template>
            <a-card :bordered="false">
                <template slot="extra" v-if="getBtnByAuth('adminPointOrderExport')">
                    <a-button type="primary" @click="search(true)" :loading="loading">导出excel</a-button>
                    <a-button @click="openExportModal">导出记录</a-button>
                </template>
                <a-table :loading="t_loading" bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="(record, index) => index">
                    <template slot="thousandFormat" slot-scope="key">{{key | thousandFormat}}</template>
                    <template slot="goodsNum" slot-scope="key">{{key | goodsNum}}</template>
                    <template slot="goodsType" slot-scope="key, row">{{['', '票券', '', '实物', '', '', '', '优惠券'][row.orderGoods[0].goodsType]}}</template>
                    <template slot="orderTime" slot-scope="a, row">{{row.orderTime ? row.orderTime : "-"}}</template>
                    <template slot="payTime" slot-scope="a, row">{{row.payTime ? row.payTime : "-"}}</template>
                    <template slot="action" slot-scope="a, row">
                        <router-link v-if="getBtnByAuth('adminPointOrderDetail')" class="text-primary" :to="{name: `pointOrderDetail${['', 'Ticket', '', 'Retail', '', '', '', 'Coupon'][row.orderGoods[0].goodsType]}`, params: {[row.orderGoods[0].goodsType === 1 ? 'transNo' : 'tradeNo']: row.tradeNo}, query: {transStateStr: row.tradeState}}">查看</router-link>
                        <span v-else class="text-disabled">查看</span>
                    </template>
                </a-table>
            </a-card>
            <report-export-modal ref="reportExportModal" :exportType="15"></report-export-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>
<script type="text/javascript">
    const columns = [
    {
        title: "交易订单号",
        dataIndex: "tradeNo"
    },
    {
        title: "会员手机号",
        dataIndex: "phone"
    },
    {
        title: "交易状态",
        dataIndex: "tradeState",
        scopedSlots: { customRender: "tradeState" }
    },
    {
        title: "购买数量",
        dataIndex: "orderGoods",
        scopedSlots: { customRender: "goodsNum" }
    },
    {
        title: "商品类型",
        dataIndex: "goodsType",
        scopedSlots: { customRender: "goodsType" }
    },
    {
        title: "下单时间",
        dataIndex: "orderTime",
        scopedSlots: { customRender: "orderTime" }
    },
    {
        title: "应收积分",
        dataIndex: "transPoint",
        scopedSlots: { customRender: "thousandFormat" }
    },
    {
        title: "支付时间",
        dataIndex: "payTime",
        scopedSlots: { customRender: "payTime" }
    },
    {
        title: "实收积分",
        dataIndex: "payPoint",
        scopedSlots: { customRender: "thousandFormat" }
    },
    {
        title: "操作",
        key: "action",
        width: 100,
        scopedSlots: { customRender: "action" }
    }]
    export default {
        name: "pointOrder",
        components: {
        },
        props: {},
        data() {
            return {
                columns,
                dataSource: [],
                detailData: {},
                orderData: {},
                total: 0,
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                loading: false,
                t_loading: true
            };
        },
        computed: {
        },
        beforeCreate() {
            this.fliterForm = this.$form.createForm(this);
        },
        methods: {
            changePage(page) {
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                this.getList()
            },
            handleReset() {
                this.fliterForm.resetFields();
                this.getList();
            },
            search(isExport) {
                this.pagination.current = 1;
                if(Boolean(isExport)) {
                    this.exportExcel();
                } else {
                    this.getList();
                }
            },
            // 获取订单列表
            getList() {
                this.fliterForm.validateFields((err, values) => {
                    if (err) return;
                    if(values.tradeNo && values.tradeNo.length > 19) {
                        this.$message.warning('交易订单号不能超过19位，请重新输入');
                        return false;
                    }
                    let orderTime = values['orderTime'] ? values['orderTime'] : [];
                    values.minOrderTime = orderTime.length > 0 ? orderTime[0].format('YYYY-MM-DD') : undefined;
                    values.maxOrderTime = orderTime.length > 0 ? orderTime[1].format('YYYY-MM-DD') : undefined;

                    let payTime = values['payTime'] ? values['payTime'] : [];
                    values.minPayTime = payTime.length > 0 ? payTime[0].format('YYYY-MM-DD') : undefined;
                    values.maxPayTime = payTime.length > 0 ? payTime[1].format('YYYY-MM-DD') : undefined;

                    delete values.orderTime;
                    delete values.payTime;
                    this.t_loading = true;
                    this.$api.order.orderSearch({
                        query: {
                            ...values,
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                            platform: 6
                        }
                    }).then(res => {
                        this.pagination.total = res.total;
                        this.dataSource = res.list || [];
                        this.t_loading = false;
                    }).catch(err => {
                        this.t_loading = false;
                    })
                });
            },
            // 导出excel
            exportExcel() {
                this.fliterForm.validateFields((err, values) => {
                    if (err) return;
                    if(values.tradeNo && values.tradeNo.length > 19) {
                        this.$message.warning('交易订单号不能超过19位，请重新输入');
                        return false;
                    }
                    let orderTime = values['orderTime'] ? values['orderTime'] : [];
                    values.minOrderTime = orderTime.length > 0 ? orderTime[0].format('YYYY-MM-DD') : undefined;
                    values.maxOrderTime = orderTime.length > 0 ? orderTime[1].format('YYYY-MM-DD') : undefined;

                    let payTime = values['payTime'] ? values['payTime'] : [];
                    values.minPayTime = payTime.length > 0 ? payTime[0].format('YYYY-MM-DD') : undefined;
                    values.maxPayTime = payTime.length > 0 ? payTime[1].format('YYYY-MM-DD') : undefined;

                    delete values.orderTime;
                    delete values.payTime;
                    this.loading = true;
                    this.$api.order.pointOrderExport({
                        query: {
                            ...values,
                            pageNum: 1,
                            pageSize: this.pagination.total
                        }
                    }).then(res => {
                        this.openExportModal();
                        this.loading = false;

                    }).catch(err => {
                        this.loading = false;
                    });
                });
            },
            /**
             * @func openExportModal 打开导出记录弹窗
             */
            openExportModal() {
                this.$refs.reportExportModal.open();
            }
        },
        created() {},
        mounted() {
            this.getList();
        },
        watch: {
        }
    };
</script>
<style lang="scss">
</style>
